// This is just an example,
// so you can safely delete all default props below

export default {
    signup: 'Registrer bruker til båtbestillingsløsningen.',
    signup_desc: 'NB! brukerkonto/pålogging til båtbestillingsløsningen er valgfri å ha/bruke for å kjøpe/reservere båtbilletter.<br/>NB! pålogging til MinSide på kolumbus.no kan ikke brukes her.',
    given_name: 'Fornavn',
    family_name: 'Etternavn',
    address_line_1: 'Adresse',
    postal_code: 'Postnr.',
    locality: 'Poststed',
    country_code: 'Land',
    phone_number: 'Mobiltelefon',
    email: 'E-post',
    email_repeat: 'Gjenta e-post',
    password: 'Passord',
    password_repeat: 'Gjenta passord',
    error_given_name: 'Fornavn må oppgis',
    error_family_name: 'Etternavn må oppgis',
    error_address_line_1: 'Adresse må oppgis',
    error_postal_code: 'Postnr. må oppgis',
    error_locality: 'Poststed må oppgis',
    error_country_code: 'Land må oppgis',
    error_phone_number: 'Mobiltelefon nummer er ikke gyldig',
    error_email: 'E-post er ikke gyldig',
    error_email_repeat: 'Repetert e-post må være den samme som oppgitt e-post',
    error_password: 'Passordet må være minst 8 tegn, og må inneholde store/små bokstaver, tall og symboler.',
    error_password_repeat: 'Repetert passord må være det samme som nytt passord.',
    error_email_exist: 'E-post adr. er allerede i bruk',
    signup_success: 'Konto registrering vellykket',
    signup_success_desc: 'Velkommen. Kontoen din er opprettet og du er nå innlogget.'
}
